import {useTranslation} from 'react-i18next';
import {useEffect, useState} from "react";

function Steps(props) {

	const {currentStep, stepsRef, promotionSettings, formSubmitError} = props;
	const {t, i18n} = useTranslation();
	const promotionType = promotionSettings.promotion_page.promotion_type;
	const [isLogoVisible, setIsLogoVisible] = useState(true);


	// Steps Content Text
	let stepsContent = null;
	switch (promotionType) {
		case 'contest':
			stepsContent = <>
				<p className="step-title">{t("Simply follow the steps to join the promotion...")}</p>
				<p className="step-content">{t("... and get a chance to win!")}</p>
			</>
			break;
		case 'code_entry':
			stepsContent = <>
				{currentStep === 1 && <>
					<p className="step-title">{t("Enter the code or batch number..")}</p>
					<p className="step-content">{t("..Which is on the packaging of the participating products.")}</p>
				</>}
				{currentStep === 2 && <>
					<p className="step-title">{t("Here is your result!")}</p>
					<p className="step-content">{t("Stay tuned for the next promotion!")}</p>
				</>}
			</>
			break;
		case 'receipt_scanning':
			stepsContent = <>
				<p className="step-title">{t("Simply follow the steps to join the promotion...")}</p>
				<p className="step-content">{t("... and get a chance to win!")}</p>
			</>
			break;

		case 'code_pep':
		case 'lottery_pep':
			stepsContent = <div className="step-potato-hunt-text">
				{currentStep === 1 && <>
					<p className="step-title">{t("Are you ready? \n Grab your Lay’s bag!")}</p>

				</>}
				{currentStep === 2 && <>
					<p className="step-title">{t("Choose your patch")}</p>
					<p className="step-content">{t("Make your selection below to begin digging")}</p>
				</>}
				{currentStep === 3 && <>
					<p className="step-title">{t("Choose your patch")}</p>
					<p className="step-content">{t("Make your selection below to begin digging")}</p>
				</>}
				{currentStep === 4 && <>
					<p className="step-title">{t("Scratch to dig")}</p>
				</>}
				{currentStep === 4.5 && <>
					<p className="step-title">{t("Have you discovered the Golden Potato?")}</p>
				</>}
				{currentStep === 5 && <>
					{/*<p className="step-title-large">{t("Thank \nyou?")}</p>*/}
					{/*<p className="step-content-large">{t("For taking part in our daily competition! Come back tomorrow for another opportunity to win €1,000.")}</p>*/}
				</>}
			</div>
			break;

		case 'code_entry_ea':
			stepsContent = <div className="step-potato-hunt-text">
				{currentStep === 1 && <>
					<p className="step-title">{t("Reedem your code")}</p>
					<p className="step-content">{t("Your unique promo code is located inside label on bottle or under ring pull on can. First 5 codes unlock free EA Sports FC™ 25 in-game rewards and automatically enroll you into weekly Prize draw. Each additional code will only get you into weekly Prize draw.")}</p>
				</>}
				{currentStep === 2 && <>
					<p className="step-title">{t("Reedem your code")}</p>
					<p className="step-content">{t("Your unique promo code is located inside label on bottle or under ring pull on can. First 5 codes unlock free EA Sports FC™ 25 in-game rewards and automatically enroll you into weekly Prize draw. Each additional code will only get you into weekly Prize draw.")}</p>
				</>}
				{currentStep === 3 && <>
					<p className="step-title">{t("Thanks for participating!")}</p>
				</>}

			</div>
			break;

		default:
			stepsContent = <>
				<p className="step-title">{t("Simply follow the steps to join the promotion...")}</p>
				<p className="step-content">{t("... and get a chance to win!")}</p>
			</>
			break;
	}


	return (
		<>
			<div className="pweu-steps">
				{isLogoVisible &&
					<img src={promotionSettings.promotion_page.logo} alt="Brand Logo" className="brand-logo"/>}

				{stepsContent}
			</div>
		</>
	);
}

export default Steps;
